var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('navbar',{staticStyle:{"position":"fixed","width":"100%","z-index":"9999"}}),_c('div',{staticClass:"main-container vigo-star__bg"},[_c('app-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }